import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

/**
 * Same-origin rewrite for API calls.
 *
 * Why: cookies set by /api/auth/login are tied to the backend host
 * (`REACT_APP_BACKEND_URL`). When the site is served from a custom domain
 * (e.g. `beta.pjrtravel.com`) but the built bundle targets the preview host
 * (`*.preview.emergentagent.com`), login cookies become cross-site and modern
 * browsers either block them (Safari/Firefox ETP) or drop them silently
 * (Chrome partitioning). Result: login succeeds server-side but the
 * browser never stores the session → every navigation bounces to /login.
 *
 * Fix: at request time, if the configured backend URL points to a different
 * origin than the current page, rewrite the URL to the current origin.
 * Kubernetes ingress handles `/api/*` routing to the backend on both domains,
 * so this is transparent and keeps cookies first-party everywhere.
 */
(function installSameOriginRewrite() {
  if (typeof window === "undefined") return;
  const currentOrigin = window.location.origin;
  axios.interceptors.request.use((config) => {
    try {
      if (typeof config.url === "string" && /^https?:\/\//i.test(config.url)) {
        const target = new URL(config.url);
        if (target.origin !== currentOrigin && /\.emergentagent\.com$/i.test(target.hostname)) {
          config.url = currentOrigin + target.pathname + target.search + target.hash;
        }
      }
    } catch (_e) {
      /* noop — fall through with original URL */
    }
    return config;
  });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
